export default "__VITE_ASSET__a1cb99ad__"